export const modalTypes = {
  DELAYED_RESOURCE: 'delayedResource',
  SIMPLE_ALERT: 'simpleAlert',
};
